import { useQuery } from '@tanstack/react-query';
import getTalkingPointList from 'Api/brief-live/getTalkingPointList';
import { getTalkingPointListRequest } from './model/request/getTalkingPointListRequest';
import getTalkingPointListResponse from './model/response/getTalkingPointListResponse';

const useGetTalkingPointList = ({ queryParams, enabled = true }) => {
  return useQuery({
    queryKey: ['talking-point-list', queryParams],
    queryFn: async () => {
      const queries = getTalkingPointListRequest(queryParams);

      const response = await getTalkingPointList(queries);

      const result = getTalkingPointListResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetTalkingPointList;
